import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// * Styles
import "../../../styles/checkbox.scss";

const CheckBox = ({ className, label, defaultValue, disabled, onChange, ...props }) => {
  let _className = `${className} checkbox`;

  const [checked, setChecked] = useState(defaultValue);

  useEffect(() => {}, []);

  const onValueChanged = (e) => {
    const checked = e.target.checked;
    setChecked(checked);
    if (onChange) onChange(checked);
  };

  return (
    <div className={_className}>
      <input
        className="checkbox__input"
        type="checkbox"
        name={label}
        id={label}
        checked={checked}
        disabled={disabled}
        onChange={onValueChanged}
      />
      <label className="checkbox__label" htmlFor={label}>
        {label}
      </label>
    </div>
  );
};

CheckBox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.bool,
  disabled: PropTypes.bool,
  onValueChanged: PropTypes.func,
};

CheckBox.defaultProps = {
  defaultValue: false,
  disabled: false,
  className: "",
};

export default CheckBox;
